import * as req from 'api/actions';
import * as c from './constants';

export const create = (payload, callback) => req.create(
  c.CREATE, 
  '/api/v1/taxpayers/miscellaneous_fee_payments',
  payload, 
  callback)

export const clearItem = (data) => req.setItem(c.CREATE, data)